import Vue from 'vue';
import types from './mutation-types';

const mutations = {
  [types.UPDATE_PAGE](state, page) {
    Vue.set(state, 'page', page);
  },
};

export default mutations;



// WEBPACK FOOTER //
// ./src/app/edit-page/store/mutations.js